import { render, staticRenderFns } from "./rightMessage.vue?vue&type=template&id=23eccef8&scoped=true"
import script from "./rightMessage.vue?vue&type=script&lang=js"
export * from "./rightMessage.vue?vue&type=script&lang=js"
import style0 from "./rightMessage.vue?vue&type=style&index=0&id=23eccef8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eccef8",
  null
  
)

export default component.exports